import { render, staticRenderFns } from "./SyncSettings.vue?vue&type=template&id=498daa38&scoped=true"
import script from "./SyncSettings.vue?vue&type=script&lang=js"
export * from "./SyncSettings.vue?vue&type=script&lang=js"
import style0 from "./SyncSettings.vue?vue&type=style&index=0&id=498daa38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498daa38",
  null
  
)

export default component.exports